import { getRTL } from '@fluentui/react';
export const getRTLFlipOptOut = () => (getRTL() ? '@noflip' : '');
//# sourceMappingURL=rtl-opt-out.js.map